module.exports = __webpack_public_path__ + "static/media/10.2046fa00.jpg";